var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcPassword(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1750 332h-695c-24-65-59-122-106-172-44-49-99-88-164-117C723 14 655 0 582 0c-91 0-174 23-250 70-75 45-137 104-184 180-44 75-66 159-66 250s22 174 66 250c47 75 109 137 184 184 76 44 159 66 250 66 73 0 141-14 203-43 65-29 120-68 164-117 47-50 82-107 106-172h27l168 164 168-164 164 164 336-336-168-164zM582 750c-44 0-86-10-125-31-36-24-66-54-90-90-23-39-35-82-35-129s12-89 35-125c24-39 54-69 90-90 39-23 81-35 125-35 47 0 89 12 125 35 39 21 69 51 90 90 23 36 35 78 35 125s-12 90-35 129c-21 36-51 66-90 90-36 21-78 31-125 31z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPassword);
export default __webpack_public_path__ + "static/media/ic_password.9728978a3d02e49cc03cbc60ea3b2348.svg";
export { ForwardRef as ReactComponent };